// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"575b6e8a","996":"f85e790f"}[chunkId] + ".chunk.css";
};